angular
    .module('empower.control')
    .directive('ngFiles', ['$parse', 'uploadFileConst', 'uploadFileWording', function ($parse, uploadFileConst, uploadFileWording) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.ngFiles);
                var isMultiple = attrs.multiple;
                var modelSetter = model.assign;
                var includedMsg = attrs.includedmsg == "";
                var acceptFileTypes = attrs.accept.split(",");
                var acceptFileTypesMINE = [];
                angular.forEach(acceptFileTypes, function(fileType) {
                    acceptFileTypesMINE.push(uploadFileConst.FILE_TYPE_ALLOWED[fileType]);
                });

                element.bind('change', function () {
                    var isValidFiles = true;
                    var values = [];
                    var fileListArr = jQuery.makeArray(element[0].files);

                    angular.forEach(fileListArr, function (item) {
                        // For mobile devices, change Image-typed input file name by the order of that image file
                        var fileName = item.name;
                        var fileNameWithoutExt = item.name.substr(0, item.name.lastIndexOf('.'));
                        var fileExt = item.name.substring(item.name.lastIndexOf('.') + 1, item.name.length);
                        
                        if (fileNameWithoutExt == 'image') {
                            var userAgent = window.navigator.userAgent;
                            // iPad or iPhone
                            if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
                                fileName = fileNameWithoutExt + (fileListArr.indexOf(item) + 1) + '.' + fileExt;
                            }
                        }

                        // Get item and check unknown file type
                        var itemType = "";
                        if (item.type == "") {
                            switch (fileExt) {
                                case "msg":
                                    itemType = "application/vnd.ms-outlook";
                                    break;
                                default:
                                    break;
                            }
                        } else {
                            itemType = item.type;
                        }

                        if (isValidFiles) {
                            var value = {
                                // File Name 
                                name: fileName,
                                //File Size 
                                size: item.size,
                                //File URL to view 
                                url: (window.URL || window.webkitURL || window || {}).createObjectURL(item),
                                // File Input Value 
                                _file: item
                            };

                            if (acceptFileTypesMINE.indexOf(itemType) >= 0) {
                                values.push(value);
                            } else {
                                isValidFiles = false;
                                //show pop-up invalid format
                                if (includedMsg) {
                                    scope.showPopUpForUploadFile(uploadFileWording.INVALID_FILE_TYPE_WITH_MESSAGE);
                                } else {
                                    scope.showPopUpForUploadFile(uploadFileWording.INVALID_FILE_TYPE);
                                }
                                
                                scope.isValidFile = false;
                            }
                        }
                    });
                    scope.$apply(function () {

                        if (isMultiple) {
                            modelSetter(scope, values);
                            scope.IsGotAnyFiles = true;
                        } else {
                            modelSetter(scope, values[0]);
                            scope.IsGotAnyFiles = true;
                        }
                    });
                });
            }
        };
    }]);